import { gql } from "@apollo/client";

export const INSERT_ANALYTICS_EVENTS = gql`
  mutation InsertAdminAnalyticsEvents(
    $objects: [admin_analytics_events_insert_input!]!
  ) {
    insert_admin_analytics_events(objects: $objects) {
      affected_rows
    }
  }
`;

export const INSERT_ANALYTICS_EVENTS_RAW_QUERY = `
  mutation InsertAdminAnalyticsEvents($objects: [admin_analytics_events_insert_input!]!) {
    insert_admin_analytics_events(objects: $objects) { affected_rows }
  }
`;
